<script setup lang="ts">
import type { TasksKanbanTask } from '@entities/task'

import { useTasksKanbanStage } from '../model/tasks-kanban-stage.hook'
import TasksKanbanCard from './tasks-kanban-card/components/TasksKanbanCard.vue'

defineOptions({
  name: 'TasksKanbanStageBody',
})

defineProps<{
  tasks: TasksKanbanTask[]
}>()

const {
  isExpired,
  isUpcoming,
  getAgentName,
  getDisciplineName,
  getDisciplineUrl,
  getKidName,
  getRelatedToType,
  getSubscriptionId,
  getSubscriptionUrl,
  getTaskName,
  getTaskUrl,
  getPriorityLabel,
  handleCardClick,
} = useTasksKanbanStage()
</script>

<template>
  <div class="tkb-stage-body">
    <TasksKanbanCard
      v-for="task in tasks"
      :key="task.id"
      :task-id="task.id"
      :task-name="getTaskName(task)"
      :task-url="getTaskUrl(task)"
      :priority="task.priority"
      :priority-label="getPriorityLabel(task)"
      :customer-name="task.customer?.full_name"
      :is-go="task.customer?.is_go ?? false"
      :customer-brand="task.customer?.brand ?? null"
      :agent-name="getAgentName(task)"
      :deadline="task.deadline"
      :kid-name="getKidName(task)"
      :discipline="getDisciplineName(task)"
      :discipline-url="getDisciplineUrl(task)"
      :related-to-type="getRelatedToType(task)"
      :subscription-id="getSubscriptionId(task)"
      :subscription-url="getSubscriptionUrl(task)"
      :expired="isExpired(task.deadline)"
      :upcoming="isUpcoming(task.deadline)"
      @click="handleCardClick"
    />
  </div>
</template>
